import script from "./TextGenPrompt.vue?vue&type=script&setup=true&lang=js"
export * from "./TextGenPrompt.vue?vue&type=script&setup=true&lang=js"

import "./TextGenPrompt.vue?vue&type=style&index=0&id=025df73a&lang=sass"

const __exports__ = script;

export default __exports__